import { RootState } from 'store';
import { useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HTML5Backend } from 'react-dnd-html5-backend';

import useQuery from '../src/hooks/useQuery';
import Overlay from './modules/Common/Components/Overlay';
import { resetErrorAction, setErrorPageAction, setErrorCodeAction } from 'modules/Error/actions';

import { WbRoutes } from 'routes';
import { hideFreshDeskUrl } from 'constants/index';
import { removeGillRoyIcon, addGillRoyIcon } from 'utils';
import WbBranchIo from 'components/wb-branch-io';
import './App.css';
import './assets/scss/index.css';
import './assets/scss/custom-antd.css';

const App = () => {
  let query = useQuery();
  const history = useNavigate();

  const isOverlay = useSelector((state: RootState) => state.uiReducer.overlay);
  const selectedIds = useSelector((state: RootState) => state.dragDrop.selectedIds);
  const errorType: string = useSelector((state: RootState) => state.errors.errorType);
  const isSelectionEmail = useSelector((state: RootState) => state.dragDrop.gillRoyMoveUp);
  const exportWidgetPermission = useSelector((state: RootState) => state?.user?.userData?.export_widget_permission);

  useEffect(() => {
    if (errorType !== '') {
      const fromQuery = query.get('from');
      const fromQueryWorkflowId = query.get('workflow_id');
      const fromQueryCampaignId = query.get('campaign_id');
      const fromQueryEmailId = query.get('email_id');
      const fromQueryContactId = query.get('contact_id');
      const fromQueryAccountId = query.get('account_id');
      let path = window.location.pathname;
      let fromAutomation = path.startsWith('/automation');

      resetErrorAction();
      setErrorCodeAction(parseInt(errorType));
      if (fromQuery === 'campaign') {
        setErrorPageAction(`/campaigns/content/audience?campaign_id=${fromQueryCampaignId}`, true);
      } else if (fromQuery === 'emailEngagement') {
        if (fromQueryContactId)
          setErrorPageAction(`/analytics/contacts/email_engagement/?contact_id=${fromQueryContactId}&row_id=0&`, true);
        else if (fromQueryAccountId)
          setErrorPageAction(`/analytics/accounts/email_engagement/?account_id=${fromQueryAccountId}&row_id=0&`, true);
      } else if (fromQuery === 'publish') {
        setErrorPageAction(
          `/campaigns/editionedit/publish/?campaign_id=${fromQueryCampaignId}&email_id=${fromQueryEmailId}`,
          true,
        );
      } else if (fromAutomation) {
        setErrorPageAction(`/automation`, true);
      } else if (fromQueryWorkflowId) {
        setErrorPageAction(`/automation/details?workflow_id=${fromQueryWorkflowId}`, true);
      } else if (!exportWidgetPermission && path.includes('settings')) {
        setErrorPageAction(`/campaigns`, true);
      }
      history('/permission_denied?error=' + errorType);
    }
  }, [errorType]);

  useEffect(() => {
    if (isOverlay) {
      removeGillRoyIcon();
    } else if (
      !hideFreshDeskUrl.includes(window.location.pathname) &&
      !isSelectionEmail &&
      // adding the following check to fix issue # https://xiqinc.atlassian.net/browse/WBN-3349
      // where the gillroy icon was showing up on the audience page in front of unlink button when selected
      !window.location.pathname.includes('campaigns/content/audience') &&
      selectedIds.length === 0
    ) {
      addGillRoyIcon();
    }
  }, [isOverlay]);

  useEffect(() => {
    let path = window.location.pathname;
    if (
      (path.startsWith('/campaigns') && hideFreshDeskUrl.includes(path)) ||
      path.startsWith('/automation') ||
      path.startsWith('/settings') ||
      path.startsWith('/welcome') ||
      path.startsWith('/unsub') ||
      path.startsWith('/resub')
    ) {
      removeGillRoyIcon();
    }
  }, [window.location.pathname]);

  useEffect(() => {
    if (selectedIds.length === 1) {
      removeGillRoyIcon();
    } else if (selectedIds.length === 0) {
      addGillRoyIcon();
    }
  }, [selectedIds.length]);

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <WbBranchIo />
        {isOverlay && <Overlay />}
        <WbRoutes />
      </DndProvider>
    </>
  );
};

export default App;